__turbopack_context__.v({
  "button-area": "GuideButton-module-scss-module__25xPLG__button-area",
  "button-area__isCard": "GuideButton-module-scss-module__25xPLG__button-area__isCard",
});
